import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
const OCCASIONS = [{
  id: 'diwali',
  name: 'Diwali',
  category: 'Festival',
  defaultText: 'Happy Diwali! Special Festive Offers'
}, {
  id: 'pongal',
  name: 'Pongal',
  category: 'Festival',
  defaultText: 'Pongal Wishes! Exclusive Deals'
}, {
  id: 'eid',
  name: 'Eid',
  category: 'Festival',
  defaultText: 'Eid Mubarak! Limited Time Offers'
}, {
  id: 'christmas',
  name: 'Christmas',
  category: 'Festival',
  defaultText: 'Merry Christmas! Year-End Sale'
}, {
  id: 'newyear',
  name: 'New Year',
  category: 'Festival',
  defaultText: 'Happy New Year! Fresh Start Offers'
}, {
  id: 'monsoon',
  name: 'Monsoon Sale',
  category: 'Seasonal',
  defaultText: 'Monsoon Special Offers'
}, {
  id: 'yearend',
  name: 'Year-End Sale',
  category: 'Seasonal',
  defaultText: 'Year-End Clearance Sale'
}, {
  id: 'launch',
  name: 'New Launch',
  category: 'Generic',
  defaultText: 'New Launch - Book Now'
}, {
  id: 'offer',
  name: 'Limited Offer',
  category: 'Generic',
  defaultText: 'Limited Time Offer - Hurry!'
}];
export function AddGreetings() {
  const navigate = useNavigate();
  const [selectedOccasion, setSelectedOccasion] = useState<string | null>(null);
  const [customText, setCustomText] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const filteredOccasions = OCCASIONS.filter(occ => filterCategory === 'all' || occ.category === filterCategory);
  const handleOccasionSelect = (occasionId: string) => {
    setSelectedOccasion(occasionId);
    const occasion = OCCASIONS.find(o => o.id === occasionId);
    if (occasion) {
      setCustomText(occasion.defaultText);
    }
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1089">
      <Sidebar data-id="element-1090" />
      <main className="flex-1" data-id="element-1091">
        <Header data-id="element-1092" />
        <StepIndicator currentStep={3} steps={STEPS} data-id="element-1093" />
        <div className="px-6 py-8" data-id="element-1094">
          <div className="max-w-5xl mx-auto" data-id="element-1095">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1096">
              Step 3: Add Greetings/Text
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1097">
              Select an occasion and customize your greeting text
            </p>

            <div className="grid grid-cols-3 gap-6" data-id="element-1098">
              <div className="col-span-2 space-y-6" data-id="element-1099">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1100">
                  <div className="flex items-center justify-between mb-6" data-id="element-1101">
                    <h3 className="font-medium text-gray-800" data-id="element-1102">
                      Select Occasion
                    </h3>
                    <div className="flex space-x-2" data-id="element-1103">
                      {['all', 'Festival', 'Seasonal', 'Generic'].map(category => <button key={category} onClick={() => setFilterCategory(category)} className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${filterCategory === category ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1104">
                            {category === 'all' ? 'All' : category}
                          </button>)}
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-3" data-id="element-1105">
                    {filteredOccasions.map(occasion => <button key={occasion.id} onClick={() => handleOccasionSelect(occasion.id)} className={`p-4 rounded-lg border-2 transition-all ${selectedOccasion === occasion.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1106">
                        <div className="flex items-center justify-between mb-2" data-id="element-1107">
                          <span className="font-medium text-gray-800 text-sm" data-id="element-1108">
                            {occasion.name}
                          </span>
                          {selectedOccasion === occasion.id && <CheckCircleIcon className="text-blue-500 flex-shrink-0" size={18} data-id="element-1109" />}
                        </div>
                        <span className="text-xs text-gray-500" data-id="element-1110">
                          {occasion.category}
                        </span>
                      </button>)}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1111">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1112">
                    Customize Text
                  </h3>
                  <div data-id="element-1113">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1114">
                      Greeting Text
                    </label>
                    <textarea value={customText} onChange={e => setCustomText(e.target.value)} placeholder="Enter your greeting text..." rows={3} maxLength={100} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1115" />
                    <p className="text-xs text-gray-500 mt-1" data-id="element-1116">
                      {customText.length}/100 characters
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-6" data-id="element-1117">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1118">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1119">Preview</h3>
                  <div className="w-full h-64 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center p-6" data-id="element-1120">
                    <p className="text-center font-medium text-gray-800" data-id="element-1121">
                      {customText || 'Your greeting will appear here'}
                    </p>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1122">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-1123">
                    Brand Guidelines
                  </h4>
                  <ul className="text-sm text-blue-800 space-y-1" data-id="element-1124">
                    <li data-id="element-1125">• Max 100 characters</li>
                    <li data-id="element-1126">• Font and size auto-applied</li>
                    <li data-id="element-1127">• Position pre-set by brand</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-6" data-id="element-1128">
              <button onClick={() => navigate('/dealer/ai-generator/step-2')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1129">
                Back
              </button>
              <button onClick={() => navigate('/dealer/ai-generator/step-4')} disabled={!selectedOccasion || !customText} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors" data-id="element-1130">
                Continue to Store Info
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}